import {useTheme} from 'react-jss';
import useStyles from './SecurityIcon.styles';

export function SecurityIcon() {
  const theme = useTheme();
  const classes = useStyles({theme});
  
  return (
    <svg className={`${classes.icon} SecurityCertificate__icon`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g className={classes.path} stroke="none" strokeWidth="1" fillRule="evenodd">
        <path
          d="M3.70035636,4.425 C9.10012451,2.525 14.9998712,2.525 20.3996394,4.425 L20.3996394,4.425 L20.9996136,4.615 L20.9994026,5.54164079 C20.9835036,7.36819862 20.5855137,17.7484706 12.4999785,21.81 L12.4999785,21.81 L12,22 L11.5000215,21.715 C3.61918337,17.7562941 3.04157495,7.87269135 3.00265816,5.69420603 L3.00265816,5.69420603 L3.00038641,4.615 Z M18.4993553,5.91523286 C14.0931642,4.63804013 9.3924682,4.69757383 5.01373255,6.09383396 C5.03733353,6.68563436 5.09409351,7.36878409 5.20474689,8.1782885 C5.45684558,10.022561 5.92181507,11.8426822 6.6444903,13.523327 C7.83399522,16.2896254 9.60993362,18.4257684 12.0859096,19.7651921 C14.4766411,18.4170189 16.2005461,16.298736 17.3627797,13.5686691 C18.0822477,11.8786512 18.5451653,10.0483573 18.7961546,8.19385662 C18.9084949,7.36380086 18.96505,6.66570214 18.9876888,6.06264409 L18.9876888,6.06264409 Z M15.2102122,7.36567213 L16.7563405,8.63432787 L11.1036278,15.5233668 L7.29238117,11.7065944 L8.70761883,10.2934056 L10.9583839,12.547434 L15.2102122,7.36567213 Z"
        />
      </g>
    </svg>
  );
}

export default SecurityIcon;
